// vendors
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const { Link, withRouter } = require('react-router-dom');
const { formatText, FormattedText } = require('core/i18n').i18n;

// components
import { Accordion } from 'commonsComponents/accordion';
import { AccordionHeader } from 'commonsComponents/accordionHeader';
import { AccordionBody } from 'commonsComponents/accordionBody';
import { OKLink } from 'commonsComponents/OKLink';

// constants
const URL_GLOBAL_ENTITIES_ACCOUNTS = '/myprofile/global/entities';
import {
  DEPOSITS,
  ACCOUNTS,
  CARDS,
  LOANSANDMORTGAGES,
  INVESTMENTS,
} from 'constants/aggregator/products';
import { PFM_NEW_FEATURES } from 'constants/flagBasedFeatures';

// utilities
import { isAggregatorProductEnabled } from 'utilities/aggregator/aggregatorToggleHelper';
import { getStringFromType } from 'utilities/aggregator/aggregatorHelper';
import { getFormattedString } from 'utilities/currencyHelper';
import { recordLink, TINK_PG_PAGE_NAME, TINK_PG_CATEGORIZER_ACTION } from 'utilities/tagging';

// assets
import cardIcon from 'routes/aggregatorTink/assets/card-icon.svg';
import wealthIcon from 'routes/aggregatorTink/assets/wealth-icon.svg';

class AggregatorResumeEntities extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      // necesary empty to handle onclick state of each accordion
    };
  }

  renderAccordion = (icon, title, text, array, total, withoutMargin, link) => {
    const { immAggregatorData, isTinkAggregator, hasSomeErrorStatuses } = this.props;

    let items = null;
    items =
      immAggregatorData.getIn(['data', 'aggregation']).size &&
      array
        .map(p => {
          const item = immAggregatorData.getIn(['data', 'aggregation', p]);
          return (
            item && {
              title: formatText(`aggregatorResume-${item.get('type')}`),
              value: getFormattedString(item.get('balance')),
              quantity: item.get('total'),
              url: `/myprofile/global/entities/${getStringFromType(item.get('type'))}`,
            }
          );
        })
        .filter(item => item);

    const divClassName = classNames('aggregator-resume-section__content__entities__entity', {
      'tink': isTinkAggregator,
      'aggregator-resume-section__content__entities__entity--expanded': this.state[title],
      'aggregator-resume-section__content__entities__entity--without-margin': withoutMargin,
      'hasSomeErrorStatuses': isTinkAggregator && hasSomeErrorStatuses,
    });

    const extraClassLink =
      'aggregator-resume-section__content__entities__accordion__header__table__name__title';

    const getAccordionBodyClassName = (className) => {
      const rootClass = !className
        ? 'aggregator-resume-section__content__entities__accordion__body'
        : `aggregator-resume-section__content__entities__accordion__body${className}`;

      return classNames(rootClass, {
        tink: isTinkAggregator,
      });
    };

    return (
      <div className={divClassName}>
        <Accordion
          onClick={() => this.setState({ [title]: !this.state[title] })}
          isExpanded={this.state[title]}
        >
          <AccordionHeader name="AccordionHeader">
            <div className="aggregator-resume-section__content__entities__accordion__header">
              <table className="aggregator-resume-section__content__entities__accordion__header__table">
                <tbody>
                  <tr>
                    <td className="aggregator-resume-section__content__entities__accordion__header__table__name">
                      {isTinkAggregator ? (
                        <img
                          className={
                            'aggregator-resume-section__content__entities__accordion__header__table__name__icon icon'
                          }
                          src={icon === 'rebrand-investments' ? wealthIcon : cardIcon}
                        />
                      ) : (
                        <i
                          className={`aggregator-resume-section__content__entities__accordion__header__table__name__icon icon ${icon}`}
                        />
                      )}
                      <OKLink
                        isOKLinkOld={true}
                        to={`${URL_GLOBAL_ENTITIES_ACCOUNTS}/${link}`}
                        modifier="dark"
                        extraClass={extraClassLink}
                      >
                        {formatText(title)}
                      </OKLink>
                    </td>
                    <td className="aggregator-resume-section__content__entities__accordion__header__table__value">
                      <div className="aggregator-resume-section__content__entities__accordion__header__table__value__text">
                        {formatText(text)}
                      </div>
                      <div className="aggregator-resume-section__content__entities__accordion__header__table__value__amount">
                        {total && getFormattedString(total)}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </AccordionHeader>
          <AccordionBody name="AccordionBody">
            <div className={getAccordionBodyClassName()}>
              <table className={getAccordionBodyClassName('__items')}>
                <tbody>
                  {items &&
                    items.map((item, i) => {
                      return (
                        <tr key={i} className={getAccordionBodyClassName('__items__item')}>
                          <td className={getAccordionBodyClassName('__items__item__title')}>
                            <Link
                              to={item.url}
                              className={getAccordionBodyClassName('__items__item__link')}
                            >
                              {item.title}
                            </Link>
                            {isTinkAggregator && (
                              <span
                                className={getAccordionBodyClassName('__items__item__quantity')}
                              >
                                ({item.quantity})
                              </span>
                            )}
                          </td>
                          <td className={getAccordionBodyClassName('__items__item__value')}>
                            {item.value}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </AccordionBody>
        </Accordion>
      </div>
    );
  };

  renderSavingsAccordion = () => {
    const { flagBasedFeatures, immAggregatorData } = this.props;
    const array = [ACCOUNTS, INVESTMENTS, DEPOSITS].filter(p =>
      isAggregatorProductEnabled(flagBasedFeatures, p)
    );

    return (
      immAggregatorData.getIn(['data', 'savingAndInvestment']) &&
      this.renderAccordion(
        'rebrand-investments',
        'aggregatorResume-savingAndInvestment',
        'aggregatorResume-totalBalance',
        array,
        immAggregatorData.getIn(['data', 'savingAndInvestment']),
        false,
        'accounts'
      )
    );
  };

  renderFinancingAccordion = () => {
    const { flagBasedFeatures, immAggregatorData } = this.props;
    const array = [CARDS, LOANSANDMORTGAGES].filter(p =>
      isAggregatorProductEnabled(flagBasedFeatures, p)
    );

    return (
      immAggregatorData.getIn(['data', 'financing']) &&
      this.renderAccordion(
        'rebrand-credit-card',
        'aggregatorResume-financing',
        'aggregatorResume-holdBalance',
        array,
        immAggregatorData.getIn(['data', 'financing']),
        true,
        'cards'
      )
    );
  };

  renderMovement(icon, text, item, percent, isFistItem = false) {
    const iconClassname = classNames(
      `aggregator-resume-section__content__entities__movements__items__table__title__icon icon icon-${icon}`,
      {
        ['aggregator-resume-section__content__entities__movements__items__table__title__icon--green']:
          isFistItem,
        ['aggregator-resume-section__content__entities__movements__items__table__title__icon--blue']:
          !isFistItem,
      }
    );

    const graphClassname = classNames(
      'aggregator-resume-section__content__entities__movements__items__table__graph__value',
      {
        ['aggregator-resume-section__content__entities__movements__items__table__graph__value--green']:
          isFistItem,
        ['aggregator-resume-section__content__entities__movements__items__table__graph__value--blue']:
          !isFistItem,
      }
    );

    return (
      <tr>
        <td className="aggregator-resume-section__content__entities__movements__items__table__title">
          <i className={iconClassname} />
          {formatText(`aggregatorResume-${text}`)}
        </td>
        <td className="aggregator-resume-section__content__entities__movements__items__table__graph">
          <div style={{ width: percent }} className={graphClassname} />
        </td>
        <td className="aggregator-resume-section__content__entities__movements__items__table__value">
          {item && getFormattedString(item)}
        </td>
      </tr>
    );
  }

  renderLink = () => {
    const { immAggregatorData, flagBasedFeatures, isTinkAggregator, history } = this.props;
    const hasNewPfmView = flagBasedFeatures.get(PFM_NEW_FEATURES);
    const pfmViewPath = hasNewPfmView
      ? '/myprofile/global/entities/expenses-by-category/'
      : '/myprofile/global/entities/expenses-by-category/all-categories/Debito%20y%20credito/Todas%20las%20cuentas';

    const handleClick = () => {
      if (isTinkAggregator) {
        recordLink(TINK_PG_PAGE_NAME, TINK_PG_CATEGORIZER_ACTION, '');
      }
      history.push(pfmViewPath);
    };

    const linkClassnames = classNames('aggregator-resume-section__content__entities__link-div', {
      tink: isTinkAggregator,
    });

    if (
      immAggregatorData.getIn(['data', 'savingAndInvestment']) ||
      immAggregatorData.getIn(['data', 'financing'])
    )
      return (
        <div className={linkClassnames}>
          <OKLink modifier="widget" inverse={true} onClick={handleClick}>
            <FormattedText value="aggregatorResume-categoriesLink" />
          </OKLink>
        </div>
      );
  };

  render() {
    return (
      <div className="aggregator-resume-section__content__entities">
        {this.renderSavingsAccordion()}
        {this.renderFinancingAccordion()}
        {this.renderLink()}
      </div>
    );
  }
}

AggregatorResumeEntities.propTypes = {
  history: PropTypes.object.isRequired,
  immAggregatorData: PropTypes.object,
  flagBasedFeatures: PropTypes.object,
  isTinkAggregator: PropTypes.bool,
  hasSomeErrorStatuses: PropTypes.bool,
};

export default withRouter(AggregatorResumeEntities);
